import * as React from 'react'
import { ProjectType } from './projectQueries'
import { History } from 'history'
import format from 'date-fns/format'

import { ThumbImage } from './'

import {
  ThumbView,
  ThumbButtonL,
  ThumbButtonR,
  ImageCaption,
  ImageCaptionHeader,
  ImageCaptionDesc,
  ImageTools
} from './Styles'
import { recordEvent } from '../../analytics'

type Props = {
  project: ProjectType
  history: History
}

export default class ProjectThumb extends React.Component<Props> {
  openProject = () => {
    recordEvent('project', 'opened')
    this.props.history.push(`/project/${this.props.project.id}/workspace`)
  }

  render() {
    const { project, history } = this.props
    const { modified, name, id, cases } = project
    const imageUrl =
      Array.isArray(cases) && cases.length > 0 ? cases[0].thumbnail : null

    return (
      <ThumbView>
        <ThumbImage imageUrl={imageUrl} onClick={this.openProject} />
        <ImageCaption>
          <ImageCaptionHeader>{name}</ImageCaptionHeader>
          <ImageCaptionDesc>{format(modified, 'MMM, YYYY')}</ImageCaptionDesc>
        </ImageCaption>
        <ImageTools>
          <ThumbButtonL onClick={this.openProject}>OPEN</ThumbButtonL>
          <ThumbButtonR
            onClick={() => history.push(`/project/${id}/details/#cases`)}
          >
            SEE INFO
          </ThumbButtonR>
        </ImageTools>
      </ThumbView>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Projects/ProjectThumb.tsx